import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './core/pages/LoginPage/LoginPage';
import DashboardPage from './core/pages/DashboardPage/DashboardPage';
import CameraDetailPage from './core/pages/CameraDetailPage/CameraDetailPage';
import Loading from './core/components/Loading/Loading';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@coreui/coreui/dist/css/coreui.min.css';
import UserManagementPage from './core/pages/UserManagementPage/UserManagementPage';
import RegistrationPage from './core/pages/RegistrationPage/RegistrationPage';
import EmailVerificationPage from './core/pages/EmailVerificationPage/EmailVerificationPage';
import axios from 'axios'; // Для запроса IP
import { useTranslation } from 'react-i18next';

// Импорт локалей для dayjs (для работы с датами)
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/es';

const PrivateRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    useEffect(() => { setIsAuthenticated(!!localStorage.getItem('token')); }, []);
    if (isAuthenticated === null) return <Loading name="Auth checking..." />;
    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
    const { i18n } = useTranslation();
    const [isLanguageSet, setIsLanguageSet] = useState(false);

    // 1. Настройка dayjs при смене языка
    useEffect(() => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') dayjs.locale('ru');
        else dayjs.locale('en');
    }, [i18n.language]);

    // 2. Определение языка при первом входе
    useEffect(() => {
        const savedLang = localStorage.getItem('i18nextLng');

        // Если язык уже сохранен в localStorage и он корректный (2 символа), пропускаем проверку IP
        if (savedLang && savedLang.length === 2) {
            setIsLanguageSet(true);
            return;
        }

        // Если языка нет, определяем по IP
        const detectLanguageByIP = async () => {
            try {
                // Используем бесплатный API для определения страны
                // Можно заменить на свой бэкенд /api/check-ip/
                const response = await axios.get('https://ipapi.co/json/');
                const country = response.data.country_code;

                let lang = 'en'; // Язык по умолчанию

                if (['RU', 'BY', 'KZ', 'UA', 'KG', 'UZ'].includes(country)) {
                    lang = 'ru';
                }
                
                // Устанавливаем язык (это также запишет его в localStorage благодаря настройкам i18n)
                i18n.changeLanguage(lang);
            } catch (error) {
                console.warn("Не удалось определить язык по IP, установлен EN", error);
                i18n.changeLanguage('en');
            } finally {
                setIsLanguageSet(true);
            }
        };

        detectLanguageByIP();
    }, [i18n]);

    // Пока определяем язык, показываем лоадер, чтобы интерфейс не "прыгал"
    if (!isLanguageSet) return <Loading name="Setting language..." />;

    return (
        <>
            <Router>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegistrationPage />} />
                    <Route path="/verify-email/:uid/:token" element={<EmailVerificationPage />} />
                    <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
                    <Route path="/camera/:cameraId" element={<PrivateRoute><CameraDetailPage /></PrivateRoute>} />
                    <Route path="/users" element={<PrivateRoute><UserManagementPage /></PrivateRoute>} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </Router>
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} />
        </>
    );
}
export default App;